import { useEffect, useState } from "react";
import Select from "react-select";
import { FIND_CITIES } from "./discoverOurServices.gql";
import { useLazyQuery } from "@apollo/client";
import { useFormikContext } from "formik";

export const CityInput = ({
  setSelectedCityOption,
  setInputValue,
  selectedCityOption,
  inputValue,
}) => {
  const [options, setOptions] = useState([]);
  const { setFieldTouched, setFieldValue, values } = useFormikContext();

  const [runSearch, { data: citiesData, error, loading: citiesLoading }] =
    useLazyQuery(FIND_CITIES, {
      fetchPolicy: "cache-and-network",
      nextFetchPolicy: "cache-first",
    });

  useEffect(() => {
    let getProductsDebounce;
    if (inputValue.length > 2) {
      getProductsDebounce = setTimeout(() => {
        runSearch({
          variables: {
            input: inputValue,
          },
        });
      }, 500);
    }
    return () => clearTimeout(getProductsDebounce);
  }, [inputValue]);

  useEffect(() => {
    if (citiesData?.cities?.items) {
      const tempOptions = citiesData?.cities?.items.map((item) => ({
        value: {
          city: item.city,
          pincode: item.pincode,
          ["state_name"]: item["state_name"],
        },
        label: item.city,
      }));
      setOptions(tempOptions);
    }
  }, [citiesData]);
  return (
    <Select
      onChange={(option) => {
        setSelectedCityOption(option);
        if (option) {
          setFieldValue("city", option.value.city);
          setFieldValue("pincode", option.value.pincode);
          if ("state" in values) {
            setFieldValue("state", option.value.state_name);
          }
        } else {
          setFieldValue("city", "");
          setFieldValue("pincode", "");
          if ("state" in values) {
            setFieldValue("state", "");
          }
        }
        setInputValue("");
      }}
      inputValue={inputValue}
      value={selectedCityOption}
      placeholder="Type to search..."
      onInputChange={setInputValue}
      options={options}
      isLoading={citiesLoading}
      onBlur={() => {
        setInputValue("");
        setFieldTouched("city", true);
        setFieldTouched("pincode", true);
      }}
      isClearable
    />
  );
};
